import { dbGet, ErrorT } from '../helper-api';
import { FileCollectionT } from 'bovaljaren-models';

const FILE_COLLECTION_API_URL = '/file-collection/active';

const FileCollectionApi = {
    getActiveFileCollections: (projectId: number, fetch = window.fetch): Promise<Response | ErrorT> => {
        const response = dbGet<FileCollectionT[]>(`${projectId}${FILE_COLLECTION_API_URL}`, fetch);

        return response;
    }
};

export default FileCollectionApi;